import React from "react";
import classes from "./checkbox.module.scss";
import PersonIcon from '@mui/icons-material/Person';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

const CheckboxMentor = ({ checker_name, id_, for_, value, onClick, selected }) => {
    return (
        <div className={classes.checker_names} onClick={() => onClick(value)}>
            <div className={classes.name}>
                <div className={classes.profile_icon}>
                    <PersonIcon />
                </div>
                <p>{checker_name}</p>
            </div>

            <div className={classes.select_checker}>
                <input checked={selected} onClick={() => onClick(value)} id={id_} type="checkbox" value={value} />
                <label htmlFor={for_} className={classes.tik}>
                    <CheckCircleRoundedIcon />
                </label>
            </div>
        </div>
    );
};

export default CheckboxMentor;
